<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_Magento_SyncDialog_Title')"
    width="500px"
    center
  >
    <el-row type="flex" justify="center">
      <el-button type="primary" :loading="syncLoading" @click="startTasks">
        {{ $t('Integrations_Magento_SyncDialog_StartSync') }}
      </el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="startSync('sync-profiles')"
      >
        {{ $t('Integrations_Magento_SyncDialog_StartProfilesSync') }}
      </el-button>
      <el-button
        type="primary"
        :loading="syncLoading"
        @click="startSync('sync-purchases')"
      >
        {{ $t('Integrations_Magento_SyncDialog_StartPurchasesSync') }}
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import { taskStatusEnum } from '@/modules/tasks/enum/TaskRecordEnums'

export default {
  name: 'MagentoSyncDialog',

  data() {
    return {
      visible: false,
      syncLoading: false
    }
  },

  methods: {
    show() {
      this.visible = true
    },

    startSync(endpoint, waitForCompleting = false) {
      return new Promise((resolve, reject) => {
        this.syncLoading = true
        RestApi(
          projectEndpoint({
            method: 'post',
            url: `integrations/magento/${this.$attrs.model.id}/${endpoint}`
          })
        )
          .then(({ data }) => {
            const taskID = data.id

            if (waitForCompleting) {
              const checkTimer = setInterval(() => {
                RestApi(
                  projectEndpoint({
                    method: 'get',
                    url: `task/records/${taskID}`,
                    params: {
                      fields: 'status'
                    }
                  })
                ).then(response => {
                  switch (response.data.status) {
                    case taskStatusEnum.DONE:
                      clearInterval(checkTimer)
                      this.syncLoading = false
                      this.visible = false
                      resolve(data)
                      break
                    case taskStatusEnum.ERROR:
                    case taskStatusEnum.FATAL:
                      clearInterval(checkTimer)
                      this.syncLoading = false
                      this.visible = false
                      reject(data)
                      break
                  }
                })
              }, 2000)
            } else {
              this.syncLoading = false
              this.visible = false
              this.$router.push({
                name: 'TaskHistory',
                query: {
                  project_id: this.$route.query.project_id
                }
              })
              resolve(data)
            }
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
            this.syncLoading = false
            this.visible = false
            reject(error)
          })
      })
    },

    startTasks() {
      this.startSync('sync-profiles', true)
        .then(_ =>
          this.startSync('sync-purchases')
            .then(_ =>
              this.$router.push({
                name: 'TaskHistory',
                query: {
                  project_id: this.$route.query.project_id
                }
              })
            )
            .catch(() => {})
        )
        .catch(() => {})
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/magento/MagentoSyncDialog.vue